import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_6ab782cc from 'nuxt_plugin_plugin_6ab782cc' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_gtm_f11598f4 from 'nuxt_plugin_gtm_f11598f4' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_toast_a7876542 from 'nuxt_plugin_toast_a7876542' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_axios_3fe7fea0 from 'nuxt_plugin_axios_3fe7fea0' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_dayjsplugin_8a809ba6 from 'nuxt_plugin_dayjsplugin_8a809ba6' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_1185e38b from 'nuxt_plugin_pluginutils_1185e38b' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_7d9bba16 from 'nuxt_plugin_pluginrouting_7d9bba16' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_e8f14dce from 'nuxt_plugin_pluginmain_e8f14dce' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_e241ec68 from 'nuxt_plugin_workbox_e241ec68' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_e0b07642 from 'nuxt_plugin_metaplugin_e0b07642' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_d7612b5a from 'nuxt_plugin_iconplugin_d7612b5a' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_nuxtplugin3f1704c6_562f1f08 from 'nuxt_plugin_nuxtplugin3f1704c6_562f1f08' // Source: ./nuxt.plugin.3f1704c6.js (mode: 'all')
import nuxt_plugin_api_caeae0b4 from 'nuxt_plugin_api_caeae0b4' // Source: ../plugins/api (mode: 'client')
import nuxt_plugin_colors_25e12c64 from 'nuxt_plugin_colors_25e12c64' // Source: ../plugins/colors (mode: 'all')
import nuxt_plugin_display_7d5eef64 from 'nuxt_plugin_display_7d5eef64' // Source: ../plugins/display (mode: 'all')
import nuxt_plugin_filters_2abc1387 from 'nuxt_plugin_filters_2abc1387' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_formatnumber_1db75f2a from 'nuxt_plugin_formatnumber_1db75f2a' // Source: ../plugins/format-number (mode: 'all')
import nuxt_plugin_highcharts_f778aea8 from 'nuxt_plugin_highcharts_f778aea8' // Source: ../plugins/highcharts.js (mode: 'client')
import nuxt_plugin_quill_23090991 from 'nuxt_plugin_quill_23090991' // Source: ../plugins/quill (mode: 'client')
import nuxt_plugin_toast_233078b3 from 'nuxt_plugin_toast_233078b3' // Source: ../plugins/toast (mode: 'client')
import nuxt_plugin_vclickoutside_626c64d5 from 'nuxt_plugin_vclickoutside_626c64d5' // Source: ../plugins/v-click-outside (mode: 'client')
import nuxt_plugin_vtooltip_128ccb90 from 'nuxt_plugin_vtooltip_128ccb90' // Source: ../plugins/v-tooltip (mode: 'client')
import nuxt_plugin_vuecarousel_50c44c8a from 'nuxt_plugin_vuecarousel_50c44c8a' // Source: ../plugins/vue-carousel (mode: 'client')
import nuxt_plugin_vuecropper_0afa865c from 'nuxt_plugin_vuecropper_0afa865c' // Source: ../plugins/vue-cropper (mode: 'client')
import nuxt_plugin_vueinfiniteloading_7913c7de from 'nuxt_plugin_vueinfiniteloading_7913c7de' // Source: ../plugins/vue-infinite-loading (mode: 'client')
import nuxt_plugin_vuemq_469da63f from 'nuxt_plugin_vuemq_469da63f' // Source: ../plugins/vue-mq (mode: 'all')
import nuxt_plugin_vuemultiselect_f82b3d8c from 'nuxt_plugin_vuemultiselect_f82b3d8c' // Source: ../plugins/vue-multiselect (mode: 'client')
import nuxt_plugin_vuestarrating_766a9b3d from 'nuxt_plugin_vuestarrating_766a9b3d' // Source: ../plugins/vue-star-rating (mode: 'client')
import nuxt_plugin_vuejstogglebutton_34c627a2 from 'nuxt_plugin_vuejstogglebutton_34c627a2' // Source: ../plugins/vue-js-toggle-button (mode: 'client')
import nuxt_plugin_flicking_7524e42a from 'nuxt_plugin_flicking_7524e42a' // Source: ../plugins/flicking (mode: 'client')
import nuxt_plugin_windowInstance_98afc0ce from 'nuxt_plugin_windowInstance_98afc0ce' // Source: ../plugins/windowInstance (mode: 'client')
import nuxt_plugin_vclickoutside_b82aadfc from 'nuxt_plugin_vclickoutside_b82aadfc' // Source: ../plugins/v-click-outside.js (mode: 'client')
import nuxt_plugin_apexcharts_4f57ad2c from 'nuxt_plugin_apexcharts_4f57ad2c' // Source: ../plugins/apexcharts.js (mode: 'client')
import nuxt_plugin_vinterpolate_1136f581 from 'nuxt_plugin_vinterpolate_1136f581' // Source: ../plugins/v-interpolate.js (mode: 'client')
import nuxt_plugin_firebase_27cb801c from 'nuxt_plugin_firebase_27cb801c' // Source: ../plugins/firebase.js (mode: 'client')
import nuxt_plugin_portalvue_8244bc84 from 'nuxt_plugin_portalvue_8244bc84' // Source: ../plugins/portal-vue.js (mode: 'client')
import nuxt_plugin_routeextensions_376d5b2a from 'nuxt_plugin_routeextensions_376d5b2a' // Source: ../plugins/route-extensions.js (mode: 'client')
import nuxt_plugin_gtmpageview_220a6c60 from 'nuxt_plugin_gtmpageview_220a6c60' // Source: ../plugins/gtm-pageview.js (mode: 'client')
import nuxt_plugin_routemeta_2fb91a98 from 'nuxt_plugin_routemeta_2fb91a98' // Source: ../plugins/route-meta.js (mode: 'client')
import nuxt_plugin_vuevirtualscroller_72f66c80 from 'nuxt_plugin_vuevirtualscroller_72f66c80' // Source: ../plugins/vue-virtual-scroller.js (mode: 'client')
import nuxt_plugin_sentry_e47869fc from 'nuxt_plugin_sentry_e47869fc' // Source: ../plugins/sentry.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Skade","htmlAttrs":{"translate":"no"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, interactive-widget=resizes-content"},{"hid":"description","name":"description","content":""},{"name":"interactive-widget","content":"resizes-content"}],"link":[{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Inter:wght@100;200;300;400;500;600;700;900&display=swap"},{"rel":"preconnect","href":"https:\u002F\u002Fauth.skade.io"},{"rel":"preconnect","href":"https:\u002F\u002Fapi.skade.io"}],"script":[{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-1HYW71D83E","async":true},{"hid":"gtag-consent","type":"text\u002Fjavascript","innerHTML":"\n        window.dataLayer = window.dataLayer || [];\n\n        function gtag(){dataLayer.push(arguments);}\n\n        \u002F\u002F we set this to ensure compliance with Google Consent v2\n        \u002F\u002F read more on this below\n        \u002F\u002F https:\u002F\u002Fsupport.axeptio.eu\u002Fhc\u002Ffr\u002Farticles\u002F22570846852753-Installation-du-Google-Consent-Mode-v2\n        \u002F\u002F https:\u002F\u002Fdevelopers.google.com\u002Ftag-platform\u002Fsecurity\u002Fguides\u002Fconsent?consentmode=advanced\n\n        gtag(\"consent\", \"default\",\n          {\n            analytics_storage: \"denied\",\n            ad_storage: \"denied\",\n            ad_user_data: \"denied\",\n            ad_personalization: \"denied\",\n            wait_for_update: 500\n          });\n\n        gtag(\"js\", new Date());\n\n        gtag(\"config\", \"G-1HYW71D83E\");"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TDZ9MBJ7')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizersByTagID":{"gtag-consent":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TDZ9MBJ7&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_6ab782cc === 'function') {
    await nuxt_plugin_plugin_6ab782cc(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_f11598f4 === 'function') {
    await nuxt_plugin_gtm_f11598f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_a7876542 === 'function') {
    await nuxt_plugin_toast_a7876542(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3fe7fea0 === 'function') {
    await nuxt_plugin_axios_3fe7fea0(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_8a809ba6 === 'function') {
    await nuxt_plugin_dayjsplugin_8a809ba6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1185e38b === 'function') {
    await nuxt_plugin_pluginutils_1185e38b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_7d9bba16 === 'function') {
    await nuxt_plugin_pluginrouting_7d9bba16(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_e8f14dce === 'function') {
    await nuxt_plugin_pluginmain_e8f14dce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_e241ec68 === 'function') {
    await nuxt_plugin_workbox_e241ec68(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_e0b07642 === 'function') {
    await nuxt_plugin_metaplugin_e0b07642(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_d7612b5a === 'function') {
    await nuxt_plugin_iconplugin_d7612b5a(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtplugin3f1704c6_562f1f08 === 'function') {
    await nuxt_plugin_nuxtplugin3f1704c6_562f1f08(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_api_caeae0b4 === 'function') {
    await nuxt_plugin_api_caeae0b4(app.context, inject)
  }

  if (typeof nuxt_plugin_colors_25e12c64 === 'function') {
    await nuxt_plugin_colors_25e12c64(app.context, inject)
  }

  if (typeof nuxt_plugin_display_7d5eef64 === 'function') {
    await nuxt_plugin_display_7d5eef64(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2abc1387 === 'function') {
    await nuxt_plugin_filters_2abc1387(app.context, inject)
  }

  if (typeof nuxt_plugin_formatnumber_1db75f2a === 'function') {
    await nuxt_plugin_formatnumber_1db75f2a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_highcharts_f778aea8 === 'function') {
    await nuxt_plugin_highcharts_f778aea8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_quill_23090991 === 'function') {
    await nuxt_plugin_quill_23090991(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_233078b3 === 'function') {
    await nuxt_plugin_toast_233078b3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vclickoutside_626c64d5 === 'function') {
    await nuxt_plugin_vclickoutside_626c64d5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vtooltip_128ccb90 === 'function') {
    await nuxt_plugin_vtooltip_128ccb90(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_50c44c8a === 'function') {
    await nuxt_plugin_vuecarousel_50c44c8a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecropper_0afa865c === 'function') {
    await nuxt_plugin_vuecropper_0afa865c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueinfiniteloading_7913c7de === 'function') {
    await nuxt_plugin_vueinfiniteloading_7913c7de(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemq_469da63f === 'function') {
    await nuxt_plugin_vuemq_469da63f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemultiselect_f82b3d8c === 'function') {
    await nuxt_plugin_vuemultiselect_f82b3d8c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuestarrating_766a9b3d === 'function') {
    await nuxt_plugin_vuestarrating_766a9b3d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejstogglebutton_34c627a2 === 'function') {
    await nuxt_plugin_vuejstogglebutton_34c627a2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_flicking_7524e42a === 'function') {
    await nuxt_plugin_flicking_7524e42a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_windowInstance_98afc0ce === 'function') {
    await nuxt_plugin_windowInstance_98afc0ce(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vclickoutside_b82aadfc === 'function') {
    await nuxt_plugin_vclickoutside_b82aadfc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_apexcharts_4f57ad2c === 'function') {
    await nuxt_plugin_apexcharts_4f57ad2c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vinterpolate_1136f581 === 'function') {
    await nuxt_plugin_vinterpolate_1136f581(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_firebase_27cb801c === 'function') {
    await nuxt_plugin_firebase_27cb801c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_portalvue_8244bc84 === 'function') {
    await nuxt_plugin_portalvue_8244bc84(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routeextensions_376d5b2a === 'function') {
    await nuxt_plugin_routeextensions_376d5b2a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmpageview_220a6c60 === 'function') {
    await nuxt_plugin_gtmpageview_220a6c60(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routemeta_2fb91a98 === 'function') {
    await nuxt_plugin_routemeta_2fb91a98(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuevirtualscroller_72f66c80 === 'function') {
    await nuxt_plugin_vuevirtualscroller_72f66c80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentry_e47869fc === 'function') {
    await nuxt_plugin_sentry_e47869fc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
